import { useState, useEffect } from "react";
import "./createProvider.css";
import SideMenu from "../../features/sideMenu/SideMenu";
import CustomButton from "../../ui/button/Button";
import { useNavigate, useParams } from "react-router-dom";
import CustomSelect from "../../ui/select/Select";
import { fieldsAddInstallers } from "../../constants/addUser.constats";
import {
  fetchInstallerById,
  updateInstallerContact,
} from "../functions/Functions";
import { itemsProviders } from "../../constants/providers";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import "./EditInstaller.responsive.css";

const EditInstaller = ({ API_URL, perfilInstaladorer }) => {
  const { id } = useParams();

  const initialPayload = {
    nombre: null,
    apellidos: null,
    email: null,
    telefono: null,
    comentarios: null,
    latitud: null,
    longitud: null,
    md5Ine: null,
    md5Credencial: null,
    md5Foto: null,
    md5Imss: null,
    md5dc3: null,
    md5CertificadoMedico: null,
    md5Otro: null,
    progresoMultimedia: null,
    extensionIne: null,
    extensionCredencial: null,
    extensionDc3: null,
    extensionOtro: null,
    extensionFoto: null,
    extensionCertificado: null,
    extensionImss: null,
    numGafete: null,
    porDefecto: null,
    esProject: null,
    estatusConexion: null,
    fecha: null,
    usuarioTrello: null,
    ultimoGradoEstudios: null,
    certificadoDc3: null,
    tokenFCM: null,
    empresa: null,
    perfilInstalador: null,
    empresaId: null,
    habilitado: null,
    fechaVencimientoIne: null,
    fechaVencimientoImss: null,
    fechaVencimientoCertificadoMedico: null,
    fechaVencimientoDc3: null,
    rfc: null,
    vigDc3: null,
    vigIne: null,
    vigImss: null,
    vigCM: null,
  };
  const [isLoading, setIsLoading] = useState(true);
  const [companyId, setCompanyId] = useState(null);
  const [payload, setPayload] = useState({ ...initialPayload });
  const confirmDialog = useConfirmDialog();
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayload((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      await updateInstallerContact(API_URL, payload);
      confirmDialog({
        html: "Contacto actualizado con éxito.",
        icon: "success",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
        onConfirm: () => navigate(`/proveedores/instaladores/${companyId}`),
      });
    } catch (error) {
      confirmDialog({
        html: `Ocurrió un error al actualizar el contacto.<br>${
          error.response?.data?.message || error.message
        }`,
        icon: "error",
        mostrarCancelar: false,
        confirmButtonText: "Aceptar",
      });
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetchInstallerById(API_URL, id);
        setPayload(response);
        setCompanyId(response?.empresa?.id);
      } catch (error) {
        console.error("Error al cargar los datos del instalador:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, [API_URL, id]);

  const addInstaller = () => (
    <div className="form-container">
      <form>
        <h1>Editar Instalador</h1>
        {fieldsAddInstallers.map((field) => (
          <div className="form-row" key={field.name}>
            <label className="form-label">
              {field.name === "lenguaje" ? "Idioma" : field.label}:
            </label>
            {field.name === "perfilInstalador" ? (
              <>
                <div className="select-label">
                  <CustomSelect
                    options={perfilInstaladorer.map((perfil) => ({
                      value: perfil.id,
                      name: perfil.nombre,
                      icon: perfil.icon,
                    }))}
                    value={payload.perfilInstalador?.id || ""}
                    name={field.name}
                    onChange={(e) => {
                      const selectedPerfil = perfilInstaladorer.find(
                        (perfil) => perfil.id === parseInt(e.target.value)
                      );
                      setPayload((prev) => ({
                        ...prev,
                        perfilInstalador: selectedPerfil || null,
                      }));
                    }}
                    height={"39px"}
                    textAlign={"left"}
                    color={"#6c757d"}
                    fontSize={"14px"}
                    fontWeight={600}
                    heightOption={"110px"}
                    topOption={"-40px"}
                    paddingTop={"8px"}
                    marginBottom={"6px"}
                  />
                </div>
              </>
            ) : (
              <input
                className="form-input"
                type="text"
                name={field.name}
                value={payload[field.name] || ""}
                onChange={handleChange}
                placeholder={`Ingresa ${
                  field.label.toLowerCase() === "rfc"
                    ? "RFC"
                    : field.label.toLowerCase()
                }`}
              />
            )}
          </div>
        ))}
        <div className="button-container">
          <CustomButton
            text={"Guardar"}
            color={"#FFFFFF"}
            border={"none"}
            background={"#62C776"}
            fontStyle={"normal"}
            fontWeight={700}
            fontSize={"14px"}
            width={"75px"}
            height={"28px"}
            type={"button"}
            onClick={handleSubmit}
          />
        </div>
      </form>
    </div>
  );

  return (
    <div
      className="editInstaller-container"
      style={{ display: "flex", height: "100%" }}
    >
      <div className="editInstaller-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProviders} />
      </div>
      <div className="editInstaller-main createUser">{addInstaller()}</div>
    </div>
  );
};

export default EditInstaller;
